<input
  [type]="props.type"
  [formControl]="formControl"
  [formlyAttributes]="field"
  class="form-control field-focus"
  [ngClass]="props.inputClass"
  [mask]="props.mask"
  [decimalMarker]="decimalMarker"
  [thousandSeparator]="thousandSeparator"
  [attr.aria-label]="props.ariaLabel | translate"
  [attr.aria-required]="props.required ? 'true' : undefined"
  [attr.aria-invalid]="showError ? 'true' : undefined"
  [attr.aria-describedby]="props.ariaDescribedByIds"
  [attr.data-testing-id]="field.key"
/>
